import Home from "../pages/Home";
import RTTaskIO from "../pages/RTTaskIO/RTTaskIO";

import { createBrowserRouter, RouterProvider, Outlet } from "react-router-dom";
import Providers from "../Providers";
import { InventoryBrowser } from "../pages/InventoryBrowser/InventoryBrowser";  
import { ExperimentPlanner2 } from "../pages/ExperimentPlanner2/ExperimentPlanner2";
import { ExperimentPlanner3 } from "../pages/ExperimentPlanner3/ExperimentPlanner3";

function AppRoutes() {
  const router = createBrowserRouter([
    {
      path: "/",
      Component() {
        return (
          <Providers>
            <Outlet />
          </Providers>
        );
      },
      children: [
        {
          path: "",
          element: <Home />,
        },
        {
          path: "task/:id",
          element: <RTTaskIO />,
        },
        {
          path: "ep2",
          element: <ExperimentPlanner2 />,
        },
        {
          path: "ep3",
          element: <ExperimentPlanner3 />,
        },
        {
          path: "ib",
          element: <InventoryBrowser />,
        },

      ],
    },
  ], {
    // Add the basename that reflects your deployment subdirectory
    basename: "/rt-tasks"
  });

  return <RouterProvider router={router} />;
}

export default AppRoutes;
